/**
 * <kamal-gift-message> — saves the "gift card + printed message" choice as cart
 * attributes so it reaches checkout and the order.
 */
if (!customElements.get('kamal-gift-message')) {
  customElements.define(
    'kamal-gift-message',
    class KamalGiftMessage extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-gift-toggle]');
        this.panel = this.querySelector('[data-gift-panel]');
        this.message = this.querySelector('[data-gift-message]');
        this.count = this.querySelector('[data-gift-count]');
        this.flagInput = this.querySelector('[data-gift-attr-flag]');
        this.messageInput = this.querySelector('[data-gift-attr-message]');
        if (!this.toggle || !this.message) return;

        this.timer = null;
        this.updateCount();

        this.toggle.addEventListener('change', () => {
          this.panel.hidden = !this.toggle.checked;
          if (this.toggle.checked) this.message.focus();
          this.sync();
          this.save();
        });

        this.message.addEventListener('input', () => {
          this.updateCount();
          this.sync();
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.save(), 600);
        });

        this.message.addEventListener('blur', () => {
          clearTimeout(this.timer);
          this.save();
        });
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
      }

      updateCount() {
        if (this.count) this.count.textContent = this.message.value.length;
      }

      get attributes_() {
        const on = this.toggle.checked;
        return {
          'Gift card': on ? 'Yes' : '',
          'Gift card message': on ? this.message.value.trim() : '',
        };
      }

      // Keep the hidden inputs in step so the checkout form submits the same values.
      sync() {
        const attrs = this.attributes_;
        if (this.flagInput) this.flagInput.value = attrs['Gift card'];
        if (this.messageInput) this.messageInput.value = attrs['Gift card message'];
      }

      save() {
        fetch(`${window.routes?.cart_update_url || '/cart/update.js'}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: this.attributes_ }),
        }).catch(() => {});
      }
    }
  );
}
